import { inject, Injectable } from '@angular/core';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

import { TitleService } from '@app/shared/title.service';

@Injectable()
export class CRTTitleStrategy extends TitleStrategy {
  private readonly title = inject(TitleService);

  override updateTitle(routerState: RouterStateSnapshot): void {
    const title = this.buildTitle(routerState);
    if (title !== undefined) {
      this.title.setTitle(title);
    }
  }
}
